import React, {Component} from 'react'
import PropTypes from 'prop-types'
import FilterOptions from "../../filters/FilterOptions"
import {
    TAGS,
    ORDER_PRINTED,
    ORDER_STATUS,
    TOTAL_ITEMS,
    AUTO_APPROVED,
    COMMIT_BLOCK,
    REQUEST_UPDATE_ORDER
} from "../../../helpers/orderFilters"
import OrdersDateFilter from "../OrdersDateFilter"
import OrdersQueryActions from "../OrdersQueryActions"
import FilterTypes from "./FilterTypes"
import FilterSizes from "./FilterSizes"
import SearchMultiField from "../../filters/SearchMultiField"
import CustomMultiSelect from "../../filters/CustomMultiSelect"
import {Select} from 'antd'
import {parseJwt} from '../../../../../helpers/parseToken'
import {getLocalData} from '../../../../../services/StorageServices'

const Option = Select.Option

class FilterOrders extends Component {
    _handleChangeMulti = (field, value) => {
        const {onChangeFilter} = this.props
        const newValues = value.trim().split(/,|\r|\n|\t|\r\n|\s|,\s|,/)

        if (typeof onChangeFilter === 'function') {
            onChangeFilter(field, [...new Set(newValues)])
        }
    }

    render() {
        const {
            filters,
            loading,
            total,
            onChangeFilter,
            onChangeType,
            onChangeSize,
            onChangeDate,
            onChangeTypeID,
            listBrand,
            listBarcodeSelected,
        } = this.props
        const disableNoBrand = !!filters.brand && filters.brand.length > 0 && !filters.brand.includes('no brand')
        const disableOptionBrand = !!filters.brand && filters.brand.length > 0 && filters.brand.includes('no brand')
        const role = parseJwt(getLocalData('accessToken')).roles || []
        const allowedRoles = ['fac_admin', 'fac_ffm']
        const canViewNamespace = role.some(item => allowedRoles.includes(item.name))

        return (
            <div className="FilterOrders">
                <div className="row mb-3 align-items-end">
                    <div className="col-12 col-xl-auto">
                        <FilterOptions
                            heading="Trạng thái file in:"
                            field="status"
                            options={ORDER_STATUS}
                            defaultOption={filters.status}
                            onChangeOption={onChangeFilter}
                        />
                    </div>

                    <div className="col-12 col-xl-auto CustomSelect">
                        <FilterOptions
                            heading={'Số lượng item:'}
                            onChangeOption={onChangeFilter}
                            defaultOption=""
                            field="total_item"
                            options={TOTAL_ITEMS} layout="select"
                        />
                    </div>

                    <div className="col-12 col-xl-12 mt-3">
                        <FilterTypes defaultValue={filters.type} onChange={onChangeType}
                                     onChangeTypeID={onChangeTypeID}/>
                    </div>

                    {
                        filters.type !== '' &&
                        <div className="col-12 col-xl-auto">
                            <FilterSizes defaultValue={filters.size} id={filters.typeId} onChange={onChangeSize}/>
                        </div>
                    }
                </div>

                <div className="row align-items-start mb-3">
                    <div className="col-6 col-xl-auto">
                        <FilterOptions
                            heading="Trạng thái item:"
                            field="production_status"
                            options={ORDER_PRINTED}
                            defaultOption={filters.production_status}
                            onChangeOption={onChangeFilter}
                        />
                    </div>

                    <div className="col-3 col-xl-auto CustomSelect">
                        <FilterOptions
                            heading={'Auto approved:'}
                            onChangeOption={onChangeFilter}
                            defaultOption=""
                            field="autoAproved"
                            options={AUTO_APPROVED}
                            layout="select"
                        />
                    </div>

                    <div className="col-3 col-xl-auto RequestSelect">
                        <CustomMultiSelect
                            name="tags"
                            label={'Request update'}
                            placeholder={'Chọn status request update'}
                            selected={filters.tags}
                            listFilters={REQUEST_UPDATE_ORDER}
                            onChangeFilters={onChangeFilter}
                        />
                    </div>
                    <div className="col-3 col-xl-auto filterBrand RequestSelect">
                        <div className="CustomMultiSelect">
                            <label htmlFor="request_update" className="mb-1 w-100 font-weight-bold">Brand</label>
                            <Select
                                name="brand"
                                className="brand"
                                mode={'multiple'}
                                onChange={(value) => onChangeFilter('brand', value)}
                                value={filters.brand}
                                allowClear
                                placeholder="Chọn brand name"
                                style={{width: '100%', maxWidth: '460px'}}
                            >
                                <Option disabled={disableNoBrand} value="no brand"> No brand</Option>
                                {listBrand.length && listBrand.map((i, index) => (
                                    <Option disabled={disableOptionBrand} value={i.value} key={index}>{i.label}</Option>
                                ))
                                }
                            </Select>
                        </div>
                    </div>
                    <div className="col-3 col-xl-auto filterBrand RequestSelect">
                        <div className="CustomMultiSelect">
                            <label className="mb-1 w-100 font-weight-bold">Tags</label>
                            <Select
                                name="listTags"
                                className="listTags"
                                mode={'tags'}
                                onChange={(value) => onChangeFilter('listTags', value)}
                                value={filters.listTags}
                                allowClear
                                placeholder="Chọn tag"
                                style={{width: '100%', maxWidth: '460px'}}
                                options={TAGS}
                            >
                                {
                                    TAGS.map((i, index) => (
                                        <Option value={i.value} key={index}>{i.label}</Option>
                                    ))
                                }
                            </Select>
                        </div>
                    </div>
                    <div className="col-3 col-xl-auto FilterWarningShip RequestSelect">
                        <div className="CustomMultiSelect">
                            <label htmlFor="request_update" className="mb-1 w-100 font-weight-bold">Cảnh báo
                                ship</label>
                            <Select
                                name="warning_ship"
                                className="warning_ship"
                                onChange={(value) => onChangeFilter('warning_ship', value)}
                                value={filters.warning_ship}
                                allowClear
                                placeholder="Cảnh báo ship"
                                style={{width: '100%', maxWidth: '460px'}}
                            >
                                <Option value="">All</Option>
                                {
                                    [
                                        {value:'completed', label: 'Đã hoàn thành'},
                                        {value:'packaged', label: 'Đã đóng gói'}
                                    ].map((i, index) => (
                                        <Option value={i.value}
                                                key={index}>{i.label}</Option>
                                    ))
                                }
                            </Select>
                        </div>
                    </div>
                    <div className="col-3 col-xl-auto CustomSelect">
                        <FilterOptions
                            heading={'Commit Day:'}
                            onChangeOption={onChangeFilter}
                            defaultOption={filters.commitBlock || ''}
                            field="commitBlock"
                            options={COMMIT_BLOCK}
                            layout="select"
                        />
                    </div>
                </div>

                <div className="row align-items-end">
                    <div className="col-12 col-xl-3">
                        <SearchMultiField
                            title={'Số đơn:'}
                            field="marketplaces"
                            placeholder="Tìm theo số đơn..."
                            onChangeInput={this._handleChangeMulti}
                        />
                    </div>

                    <div className="col-12 col-xl-3">
                        <SearchMultiField
                            title={'Order number:'}
                            field="order_number"
                            placeholder="Tìm theo order name..."
                            onChangeInput={this._handleChangeMulti}
                        />
                    </div>

                    {canViewNamespace && <div className="col-12 col-xl-3">
                        <SearchMultiField
                            title={'Namespace:'}
                            field="namespace"
                            placeholder="Namespace..."
                            onChangeInput={this._handleChangeMulti}
                        />
                    </div>}

                    <div className="col-12 col-xl-auto">
                        <OrdersDateFilter
                            filters={filters}
                            onDatesChange={onChangeDate}
                        />
                    </div>

                    <div className="font-weight-bold ml-auto col-12 col-xl-auto d-flex align-items-center TotalCustom">
                        <OrdersQueryActions loading={loading} query={filters} total={total}
                                            listBarcodeSelected={listBarcodeSelected}/>
                        <span className="Total ml-3">{total} items</span>
                    </div>
                </div>
            </div>
        )
    }
}

FilterOrders.propTypes = {
    filters: PropTypes.object,
    loading: PropTypes.bool,
    total: PropTypes.number,
    onChangeFilter: PropTypes.func.isRequired,
    onChangeType: PropTypes.func.isRequired,
    onChangeDate: PropTypes.func.isRequired,
    onChangeSize: PropTypes.func.isRequired,
}

export default FilterOrders
